<mat-card class="mat-card mat-focus-indicator mat-elevation-z0">
    <div class="custom-scroller">
    <div class="d-flex flex-column flex-xl-row">
      <!-- LEFT COLUMN  -->
      <div
        class="col-sm-12 col-xl-6 pe-0 pe-xl-3 border-end d-flex flex-column flex-nowrap gap-2"
      >
        <app-asset-detail [displayAtTop]="true" [assetData]="asset">
        </app-asset-detail>
      </div>
      <!-- RIGHT COLUMN  -->
      <div
        class="col-sm-12 col-xl-6 ps-5 pe-0 pe-xl-3 d-flex flex-column flex-nowrap gap-2 pt-4"
      >
        <div class="w-100">
          <mat-card class="mat-card mat-focus-indicator mat-elevation-z0">
            <div class="d-flex align-items-center justify-content-between">
              <p class="font-14 font-semibold mb-2 ng-star-inserted">
                Duplicate Asset(s)
              </p>
              <button
                type="submit"
                class="common-button medium black mat-elevation-z0 rounded-corners me-1 mb-1 no-min-width font-11 small"
                mat-button
                mat-raised-button
                (click)="openEditDrawer()" style="padding: 0px 15px !important;"
              >
                Edit
              </button>
            </div>
            <div class="w-100 mat-stepper-header">
              <ng-container
                *ngFor="
                  let duplicateAssetId of assetDuplicateIds;
                  let i = index
                "
              >
                <mat-button-toggle
                  class="duplicate-number"
                  [value]="duplicateAssetId"
                  (change)="onDuplicateChange($event.value)"
                  [checked]="selectedDuplicate === duplicateAssetId"
                >
                  <span class="circle-text">{{ i + 1 }}</span>
                </mat-button-toggle>
              </ng-container>
            </div>
          </mat-card>
        </div>

        <app-asset-detail
          [hideButtons]="true"
          [assetDataID]="selectedDuplicate"
          [assetIdFromParent]="true"
          [displayAtTop]="true"
        ></app-asset-detail>
      </div>
    </div>
    </div>
  </mat-card>
<mat-sidenav-container class="example-container" [hasBackdrop]="true">
  <mat-sidenav
    [fixedInViewport]="true"
    #drawer
    mode="over"
    class="lg"
    position="end"
    [disableClose]="true"
    [opened]="openAssetEditDrawer"
  >
    <app-edit-asset
      *ngIf="openAssetEditDrawer"
      [assetId]="selectedDuplicate"
      (dismissEditAssetDrawer)="closeEditAssetDrawer()"
    ></app-edit-asset>
  </mat-sidenav>
</mat-sidenav-container>
